// src/components/OptionsChainPicker.jsx
import { useEffect, useState } from "react";
import api from "../utils/api";

export default function OptionsChainPicker({
    userId,
    onSelect,
    initialTicker = "",
}) {
    const [symbol, setSymbol] = useState(initialTicker || "AAPL");
    const [expirations, setExpirations] = useState([]);
    const [expiration, setExpiration] = useState("");
    const [strikes, setStrikes] = useState([]);
    const [right, setRight] = useState("call");
    const [strike, setStrike] = useState("");

    // helper: fetch expirations for a specific symbol
    const fetchExpFor = async (sym) => {
        if (!sym) return;
        const { data } = await api.get("/api/options/chains", {
            params: { user_id: userId, symbol: sym },
        });
        setExpirations(data.expirations || []);
        setExpiration("");
        setStrikes([]);
    };

    const fetchExp = async () => {
        await fetchExpFor(symbol);
    };

    const fetchStrikes = async (e) => {
        const exp = e.target.value;
        setExpiration(exp);
        if (!exp) {
            setStrikes([]);
            return;
        }
        const { data } = await api.get("/api/options/chains", {
            params: { user_id: userId, symbol, expiration: exp },
        });
        setStrikes(data.strikes || []);
    };

    // on first mount: load for current symbol (AAPL or initialTicker)
    useEffect(() => {
        fetchExp();
       
    }, []);

    // when initialTicker changes (e.g. from /options-search?ticker=TSLA)
    useEffect(() => {
        if (!initialTicker) return;
        const upper = initialTicker.toUpperCase();
        setSymbol(upper);
        fetchExpFor(upper);
        
    }, [initialTicker]);

    return (
        <div className="p-4 bg-zinc-900 rounded-2xl space-y-3">
            <h3 className="text-lg font-semibold">Options Chain</h3>
            <div className="grid grid-cols-2 gap-2">
                <input
                    className="bg-zinc-800 rounded px-3 py-2"
                    value={symbol}
                    onChange={(e) =>
                        setSymbol(e.target.value.toUpperCase())
                    }
                />
                <button
                    onClick={fetchExp}
                    className="bg-zinc-700 rounded px-3"
                >
                    Load
                </button>

                <select
                    className="bg-zinc-800 rounded px-3 py-2 col-span-2"
                    value={expiration}
                    onChange={fetchStrikes}
                >
                    <option value="">Select Expiration</option>
                    {expirations.map((x) => (
                        <option key={x} value={x}>
                            {x}
                        </option>
                    ))}
                </select>

                <select
                    className="bg-zinc-800 rounded px-3 py-2"
                    value={right}
                    onChange={(e) => setRight(e.target.value)}
                >
                    <option value="call">Call</option>
                    <option value="put">Put</option>
                </select>

                <select
                    className="bg-zinc-800 rounded px-3 py-2"
                    value={strike}
                    onChange={(e) => setStrike(e.target.value)}
                >
                    <option value="">Strike</option>
                    {strikes.map((s) => (
                        <option key={s} value={s}>
                            {s}
                        </option>
                    ))}
                </select>
            </div>

            <button
                disabled={!symbol || !expiration || !strike}
                onClick={() =>
                    onSelect &&
                    onSelect({ symbol, expiration, right, strike })
                }
                className="bg-blue-600 rounded px-4 py-2 disabled:opacity-50"
            >
                Use Selection
            </button>
        </div>
    );
}
